import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Card, Loader, Table} from 'semantic-ui-react';
import {warehouses} from '../../../../common/dictionaries/parameters';

class ReviewedItemsTable extends Component {
  componentDidMount() {
    const {agency} = this.props;
    this.props.fetchScanningReviewedItemsList(agency, warehouses.main);
  }
  
  renderReviewedItems() {
    const {agency, reviewedItems} = this.props;

    if (!agency) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='3'>Seleccione una Agencia</Table.Cell>
        </Table.Row>
      );
    }

    if (!reviewedItems.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='3'>No hay items revisados</Table.Cell>
        </Table.Row>
      );
    }

    return reviewedItems.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.verifiedQuantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTableBody() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }

    return (
      <Table.Body>
        {this.renderReviewedItems()}
      </Table.Body>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {this.renderTableBody()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'agency': state.scanning.agencyData,
    'loading': state.scanning.loadingReviewedItemsList,
    'reviewedItems': state.scanning.reviewedItemsList,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchScanningReviewedItemsList,
} = Actions;

export default connect(mapStateToProps, {
  fetchScanningReviewedItemsList,
})(ReviewedItemsTable);
